import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { affiliatedRestaurantsTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { getVenuesV3 } from '../../../../../ui-kitchen/src/api';

// useAffiliatedRestaurantsState Custom Hook
//
// Listens for updates to core date, seats, or time values, and updates accordingly.
// Returns affiliatedRestaurants
const useAffiliatedRestaurantsState = ({
  venueState = {},
}) => {
  const [affiliatedRestaurants, setAffiliatedRestaurants] = useState([]);
  useEffect(() => {
    const { customAffiliations, venue } = venueState;

    if (!(customAffiliations?.length && !isEmpty(venue))) return;
    const fetchData = () => getVenuesV3({
      lat: venue.location?.coords?.lat,
      long: venue.location?.coords?.long,
      venue_ids: customAffiliations.join(','),
    }).then((response) => {
      const transformedVenues = affiliatedRestaurantsTransform(response);
      const affiliatedVenues = transformedVenues
        .filter((v) => v.location?.code === venue.location?.code)
        .slice(0, 3);
      setAffiliatedRestaurants(affiliatedVenues);
    });
    fetchData();
  }, [venueState.customAffiliations, venueState.venue]);
  return affiliatedRestaurants;
};

export default useAffiliatedRestaurantsState;
